//import './setup-fetch-logger';  // 1) debug (dev only)
import "./transformers-env";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const TITLES = {
  dd: "DueDiligence",
  ii: "I&I",
  cp: "Cyber",
  gs: "Global Signals",
};

const variant =
  (process.env.REACT_APP_IS_DD === "true" && "dd") ||
  (process.env.REACT_APP_IS_II === "true" && "ii") ||
  (process.env.REACT_APP_IS_CP === "true" && "cp") ||
  (process.env.REACT_APP_IS_GS === "true" && "gs") ||
  null;

document.title = TITLES[variant] || "App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
